<!--充电枪详情-->
<template>
    <div>
        <v-app-bar
            app
            :style="{
                backgroundImage: navigationMode == 'horizontal' ? 'white' : theme.topBarBgColor,
                borderBottom: '#bfbfbf 2px solid',
                color: theme.pageFontColor,
                backgroundColor: navigationMode == 'horizontal' ? theme.topBarBgColor : 'white',
            }"
            :color="theme.topBarBgColor"
            height="45vh"
            flat
            :class="navigationMode == 'horizontal' ? 'mt-15' : ''"
        >
            <el-page-header @back="back" content="充电枪详情"></el-page-header>
            <v-spacer></v-spacer>
            <v-chip
                label
                :color="theme.titleBgColor"
                class="mr-4"
                :text-color="theme.titleFontColor"
                @click="edit()"
            >
                <i class="el-icon-edit mr-3"></i>
                修改信息
            </v-chip>
            <v-chip
                label
                :color="theme.titleBgColor"
                class="mr-4"
                :text-color="theme.titleFontColor"
                @click="deleteConnector()"
            >
                <i class="el-icon-delete mr-3"></i>
                删除
            </v-chip>
            <v-chip
                label
                :color="theme.titleBgColor"
                class="mr-4"
                :text-color="theme.titleFontColor"
                @click="resetConnector()"
            >
                <i
                    style="color: red;font-size: 20px;font-weight: 1000"
                    class="el-icon-refresh mr-3"
                ></i>
                重置充电枪
            </v-chip>
        </v-app-bar>
        <v-container fluid class="mt-n6">
            <v-row>
                <v-col cols="12" md="12">
                    <v-card outlined class="pa-4" :color="theme.elementBgColor">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane name="first">
                                <span
                                    slot="label"
                                    :style="{
                                        color:
                                            activeName == 'first' ? '#4dabf7' : theme.pageFontColor,
                                    }"
                                >
                                    充电枪信息
                                </span>
                                <div
                                    class="ewm"
                                    :style="{
                                        background: theme.pageBgColor,
                                        borderBottom: '0.5rem solid #ffffff',
                                        paddingTop: '0.8rem',
                                    }"
                                >
                                    <img
                                        ref="bg"
                                        :src="ewmPath"
                                        alt
                                        width="45%"
                                        height="45%"
                                        v-show="false"
                                    />
                                    <a id="downloadImg"></a>
                                    <div class="code">
                                        <div id="qrcode" ref="qrCodeUrl"></div>
                                    </div>
                                    <div class="downloadBtn">
                                        <el-button
                                            type="primary"
                                            :icon="downloadIcon"
                                            circle
                                            size="mini"
                                            @click="downloadImg"
                                        ></el-button>
                                    </div>
                                </div>
                                <v-card
                                    v-loading="loading"
                                    element-loading-text="加载中"
                                    element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(255,252,252, 0.8)"
                                    flat
                                    outlined
                                    class="pa-3 pb-n4"
                                    :color="theme.pageBgColor"
                                >
                                    <v-row>
                                        <v-col
                                            cols="6"
                                            md="6"
                                            v-for="(item, index1) in gunDataArr"
                                            :key="'gun' + index1"
                                            style="height:3.2em"
                                        >
                                            <el-form
                                                label-position="right"
                                                label-width="12vw"
                                                class="mt-2"
                                            >
                                                <el-form-item
                                                    class="mt-n3"
                                                    :label="item.title + '：'"
                                                    :style="{
                                                        backgroundColor: theme.elementBgColor,
                                                        color: theme.pageFontColor,
                                                        fontSize: '10vw',
                                                    }"
                                                >
                                                    <el-link
                                                        type="primary"
                                                        @click="showSite"
                                                        :underline="false"
                                                        icon="el-icon-view el-icon--right"
                                                        v-if="item.title === '站点'"
                                                    >
                                                        {{ item.info }}
                                                    </el-link>
                                                    <div v-if="item.title != '站点'">
                                                        {{ item.info }}
                                                    </div>
                                                </el-form-item>
                                            </el-form>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </el-tab-pane>
                            <el-tab-pane name="second">
                                <span
                                    slot="label"
                                    :style="{
                                        color:
                                            activeName == 'second'
                                                ? '#4dabf7'
                                                : theme.pageFontColor,
                                    }"
                                >
                                    订单
                                </span>
                                <order-table ref="orderTable" :searchData="searchData" />
                            </el-tab-pane>
                        </el-tabs>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog scrollable v-model="isEdit" width="40rem" overlay-color="#262626">
            <connector-form
                ref="addConnector"
                :isEdit="isEdit"
                :isAdd="false"
                @cancel="cancel"
                @refresh="refresh"
            />
        </v-dialog>
        <el-dialog title="站点信息" :visible.sync="isShowSite" width="60%">
            {{ site }}
        </el-dialog>
    </div>
</template>
<script>
String.prototype.byteLength = function() {
    var length = 0;
    Array.from(this).map(function(char) {
        if (char.charCodeAt(0) > 255) {
            //字符编码大于255，说明是双字节字符
            length += 2;
        } else {
            length++;
        }
    });

    return length;
};
String.prototype.pxWidth = function(font) {
    var canvas =
            String.prototype.pxWidth.canvas ||
            (String.prototype.pxWidth.canvas = document.createElement("canvas")),
        context = canvas.getContext("2d");
    font && (context.font = font);
    var metrics = context.measureText(this);
    return metrics.width;
};
import OrderTable from "@/components/Table/OrderTable";
import ConnectorForm from "@/components/Form/ConnectorForm";
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
import util from "@/util";
import store from "@/store";
export default {
    name: "GunDetails",
    data() {
        return {
            activeName: "first",
            loading: true,
            gunDataArr: [
                {
                    siteName: null,
                    title: "站点",
                    info: null,
                },
                {
                    updatetime: null,
                    title: "更新时间",
                    info: null,
                },
                {
                    name: null,
                    title: "枪名称",
                    info: null,
                },

                {
                    type: null,
                    title: "设备模式",
                    info: null,
                },
                {
                    connector_id: null,
                    title: "充电枪编码",
                    info: null,
                },
                {
                    power: null,
                    title: "额定功率",
                    info: null,
                },
                {
                    equipment_id: null,
                    title: "充电桩编码",
                    info: null,
                },
                {
                    v_upper: null,
                    title: "电压上限(伏特)",
                    info: null,
                },
                {
                    cecName: null,
                    title: "互联互通公司",
                    info: null,
                },
                {
                    v_lower: null,
                    title: "电压下限(伏特)",
                    info: null,
                },
                {
                    status: null,
                    title: "状态",
                    info: null,
                },
                {
                    current: null,
                    title: "额定电流",
                    info: null,
                },
            ],
            searchData: {
                connector_id: null,
            },
            isEdit: false,
            isShowSite: false,
            site: null,
            downloadIcon: "el-icon-download",
        };
    },
    watch: {
        gunData: {
            handler(val) {
                if (val) {
                    this.dealInfo();
                }
            },
            deep: true,
        },
    },
    components: {
        OrderTable,
        ConnectorForm,
    },
    computed: {
        ...mapState([
            "gunData",
            "navigationMode",
            "theme",
            "equipmentInfo",
            "contactInfo",
            "siteList",
            "siteInfo",
            "ewmPath",
        ]),
    },
    async mounted() {
        if (!this.gunData) {
            this.$router.go(-1);
            return;
        }
        await store.dispatch("getSite", { from: 0, limit: 10000 });
        this.dealInfo();
        this.creatQrCode();
    },
    methods: {
        /*创建二维码*/
        creatQrCode() {
            // console.log(this.gunData);
            // console.log(this.gunDataArr);
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: "http://ecar.meisenpay.com/evc/" + this.gunData.connector_id, // 需要转换为二维码的内容
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
            });
        },
        async downloadImg() {
            this.downloadIcon = "el-icon-loading";
            let data = this.JsonData(this.gunDataArr);
            let connectorName = data[2].info;
            let connector_id = data[4].info;
            let siteName = data[0].info;
            let name = (siteName + "-" + connectorName + "-" + connector_id).toString();
            const canvas = document.createElement("canvas"); //构建画布
            let img2 = this.$refs.bg;  //获取背景图
            let img2Height = img2.naturalHeight + 60;
            let img2Width = img2.naturalWidth + 60;
            var img = document.getElementById("qrcode").getElementsByTagName("img")[0];  //获取二维码图片
            let imgHeight = img.naturalHeight;
            let imgWidth = img.naturalWidth;
            canvas.height = 2008
            canvas.width = 1475;
            let context = canvas.getContext("2d");
            let ewmHeight = 500; //二维码图片高度
            let ewmwidth = 500; //二维码图片宽度
            let left_x = 860; //二维码距离左边
            let top_y = 520; //二维码距离顶部边
            context.drawImage(img2, 0, 0, img2Width, img2Height); // 添加背景图
            context.drawImage(img, 0, 0, imgWidth, imgHeight, left_x, top_y, ewmHeight, ewmHeight);  //添加二维码图片
            context.fillStyle = "black"; // 设置文字的填充颜色
            context.font = "normal 45px normal"; // 设置文字的填充样式
            let ll = ewmHeight / 2 + left_x - connector_id.pxWidth(context.font) / 2;
            context.fillText(connector_id, ll, top_y + ewmHeight + 60);
            let a = siteName.match(/美森宝-(\S*)/) ? siteName.match(/美森宝-(\S*)/)[1] : siteName;
            let ll2 = ewmHeight / 2 + left_x - a.pxWidth(context.font) / 2;
            context.fillText(a, ll2, top_y + ewmHeight + 115);
            // 构造url
            var url = canvas.toDataURL("image/png");
            let ah = document.createElement("a");
            ah.href = url;
            ah.download = name;
            ah.click();
            this.downloadIcon = "el-icon-download";
        },
        showSite() {
            this.isShowSite = true;
            for (let i = 0; i < this.siteInfo.length; i++) {
                if (this.gunData.selectSite == this.siteInfo[i].id) {
                    this.site = this.siteInfo[i];
                }
            }
        },
        handleClick(tab, event) {
            if (tab.name == "second") {
                this.searchData.connector_id = this.gunData.connector_id;
            }
        },
        async refresh() {
            await store.dispatch("getSite", { from: 0, limit: 10000 });
            this.dealInfo();
        },
        /*返回*/
        back() {
            if (this.$refs.addConnector) {
                Object.keys(this.$refs.addConnector.form).forEach(key => {
                    this.$refs.addConnector.form[key] = null;
                });
            }
            this.$router.go(-1);
            store.commit("SET_GUN_DETAIL", null);
            // this.searchData.connector_id = null;
        },
        /*充电枪状态*/
        status(status) {
            let textArr = [
                {
                    id: 0,
                    value: "离线",
                },
                {
                    id: 1,
                    value: "空闲",
                },
                {
                    id: 2,
                    value: "占用（未充电）",
                },
                {
                    id: 3,
                    value: "占用（充电中）",
                },
                {
                    id: 4,
                    value: "占用（预约锁定）",
                },
                {
                    id: 254,
                    value: "冻结",
                },
                {
                    id: 255,
                    value: "故障",
                },
            ];
            let text = "";
            textArr.forEach((val, index) => {
                if (val.id == status) {
                    text = val.value;
                }
            });
            return text;
        },
        /*模式*/
        model(type) {
            let textArr = [
                {
                    id: 1,
                    value: "家用插座",
                },
                {
                    id: 2,
                    value: "交流插座",
                },
                {
                    id: 3,
                    value: "交流桩",
                },
                {
                    id: 4,
                    value: "直流桩",
                },
                {
                    id: 5,
                    value: "无线",
                },
                {
                    id: 6,
                    value: "其他",
                },
            ];
            let text = "";
            textArr.forEach((val, index) => {
                if (val.id == type) {
                    text = val.value;
                }
            });
            return text;
        },
        /*修改充电枪信息*/
        edit() {
            this.isEdit = true;
        },
        cancel() {
            this.isEdit = false;
        },
        /*处理充电枪信息*/
        async dealInfo() {
            for (let i = 0; i < this.gunDataArr.length; i++) {
                for (let key1 in this.gunData) {
                    for (let key2 in this.gunDataArr[i]) {
                        if (key1 == key2) {
                            this.gunDataArr[i].info = this.gunData[key1];
                        }
                        if (key2 === "type" && key1 === "type") {
                            this.gunDataArr[i].info = this.model(this.gunData[key1]);
                        }
                        if (key2 === "status" && key1 === "status") {
                            this.gunDataArr[i].info = this.status(this.gunData[key1]);
                        }
                    }
                }
            }
            if (this.gunData) {
                await store.dispatch("getEquipment", { station_id: this.gunData["selectSite"] });
            }
            if (this.equipmentInfo) {
                for (let i = 0; i < this.equipmentInfo.length; i++) {
                    if (this.gunData.equipment_id === this.equipmentInfo[i].id) {
                        this.gunDataArr[6].info = this.equipmentInfo[i].cec_equipment_id;
                    }
                }
            }
            if (!this.gunData.siteName) {
                for (let i = 0; i < this.siteList.length; i++) {
                    for (let j = 0; j < this.siteList[i].children.length; j++) {
                        if (this.gunData.selectSite === this.siteList[i].children[j].id) {
                            this.gunDataArr[0].info = this.siteList[i].children[j].value;
                        }
                    }
                }
            }
            if (!this.gunData.cecName) {
                for (let i = 0; i < this.contactInfo.length; i++) {
                    if (this.gunData.cec_id === this.contactInfo[i].id) {
                        this.gunDataArr[8].info = this.contactInfo[i].name;
                    }
                }
            }
            this.loading = false;
        },
        //删除充电枪
        deleteConnector() {
            let params = {
                postData: { id: this.gunData.id },
                callback: () => {
                    this.back();
                },
            };
            const h = this.$createElement;
            this.$confirm("是否删除充电枪：" + this.gunData.name, "提示", {
                title: "提示",
                message: h("p", null, [
                    h("span", null, "是否删除充电枪：  "),
                    h("i", { style: "color: red" }, this.gunData.name),
                ]),
                showCancelButton: true,
                center: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    store.dispatch("deleteConnector", params);
                })
                .catch(() => {});
        },
        //重置充电枪充电状态
        resetConnector() {
            let that = this;
            this.$confirm("是否重置充电枪：" + this.gunData.name, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    that.resetConnectorFun();
                })
                .catch(() => {});
        },
        async resetConnectorFun() {
            let params = {
                postData: { connector_id: this.gunData.connector_id },
                callback: () => {
                    this.back();
                },
            };
            await store.dispatch("resetConnector", params);
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
    },
    beforeRouteEnter(to, from, next) {
        if (from.path === "/devices/gun") {
            from.meta.keepAlive = true;
        } else {
            from.meta.keepAlive = false;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === "/order/details") {
            from.meta.keepAlive = true;
        } else {
            from.meta.keepAlive = false;
            store.commit("SET_GUN_DETAIL", null);
        }
        next();
    },
};
</script>
<style scoped>
#qrcode {
    /* margin-left: 100px; */
}
.img3 {
    opacity: 0;
}
.ewm {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.code {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 13.5rem;
    height: 13.5rem;
    border: 1px solid #bfbfbf;
    background-color: #ffffff;
}
.downloadBtn {
    width: 5rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

/*下载*/ // async downloadImg() { // let data = this.JsonData(this.gunDataArr); // let connectorName
= data[2].info; // let connector_id = data[4].info; // let siteName = data[0].info; // let name =
(siteName + "-" + connectorName + "-" + connector_id).toString(); // // console.log(name); // var
img = document.getElementById("qrcode").getElementsByTagName("img")[0]; // // console.log(img); //
//构建画布; // var canvas = document.createElement("canvas"); // console.log(canvas); //
canvas.width = img.width; // canvas.height = img.height; // await
canvas.getContext("2d").drawImage(img, 0, 0); // // 构造url // // var url =
canvas.toDataURL("image/png"); // // console.log(url); // let url = await
this.onCreateCanvas(canvas.toDataURL("image/png"); // console.log(url); //
document.getElementById("downloadImg").setAttribute("href", url); //
document.getElementById("downloadImg").setAttribute("download", name); //
document.getElementById("downloadImg").click(); // }, /*生成文字*/ // onCreateCanvas(src) { // let
img = new Image(); // img.src = src; // canvas画布导出图片 // console.log(img); // let img2 =
this.$refs.bg; // let imgHeight = img.naturalHeight; // let imgWidth = img.naturalWidth; // let
img2Height = img2.naturalHeight; // let img2Width = img2.naturalWidth; // // let canvasWidth =
imgWidth; // 这里设置固定值 // // let canvasHeight = imgHeight + 40; // let canvasWidth = img2Width;
// 这里设置固定值 // let canvasHeight = img2Height; // let canvas =
document.createElement("canvas"); // let context = canvas.getContext("2d"); // canvas.width =
canvasWidth; // canvas画布宽度 // canvas.height = canvasHeight; // canvas画布高度 //
context.drawImage(img2, 0, 0, img2Width, img2Height); // 加入图片2 // context.drawImage(img, 0, 0,
imgWidth, imgHeight, 800, 420, imgWidth, imgHeight); // // context.drawImage(img, 0, 0, 300,
imgHeight, 100, 100); // 加入图片1 // context.fillStyle = "black"; // 设置文字的填充颜色 //
context.font = "normal 35px normal"; // 设置文字的填充样式 // context.textAlign = "center"; //
context.textAlign = "center"; // context.fillText(connector_id, imgWidth / 2, 40 + imgHeight); //
context.fillText("测试", 0, 460 + imgHeight); // 在画布中添加文字 // let url =
canvas.toDataURL("image/png"); // canvas画布导出图片 // console.log(url); // return url; // },
